/**
 * 18+ 年龄门：首访强制确认（合规硬要求）。
 * - 命中 localStorage 记忆则直接放行；
 * - 后台把「年龄门开关」关掉时整块跳过（settings.ageGate === false）。
 */
import { useState, type ReactNode } from "react";
import { usePlatform } from "../lib/bootstrap.tsx";
import { ageGate } from "../lib/session.ts";
import { Button } from "./ui.tsx";

export default function AgeGate({ children }: { children: ReactNode }) {
  const { settings, loading, error, reload, configUpdatedAt } = usePlatform();
  const [passed, setPassed] = useState(() => ageGate.passed());
  const [declined, setDeclined] = useState(false);

  if (loading) return <div className="py-20 text-center text-sm text-cream-dim">正在唤醒小游戏们…</div>;
  // 一次都没拿到过配置（连缓存都没有）时，别把用户永远晾在加载文案上：给错误和重试
  if (error && configUpdatedAt === 0) {
    return (
      <div className="app-shell items-center justify-center pt-16">
        <div className="card w-full max-w-md text-center">
          <h2 className="neon-title text-xl">读不到站点配置</h2>
          <p className="mt-3 text-sm leading-relaxed text-cream-dim">{error}</p>
          <div className="mt-5">
            <Button onClick={() => void reload()}>重试</Button>
          </div>
        </div>
      </div>
    );
  }
  if (!settings.ageGate || passed) return <>{children}</>;

  return (
    <div className="app-shell items-center justify-center pt-16">
      <div className="card w-full max-w-md text-center">
        <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full border border-danger/60 bg-danger/15 text-2xl">
          🔞
        </div>
        <h2 className="neon-title text-2xl">本站仅面向成年人</h2>
        <p className="mt-3 text-sm leading-relaxed text-cream-dim">
          站内含暧昧向互动内容，部分内容仅成年人可访问。进入即表示你已年满 18 周岁，
          并同意对所有互动保持自愿、可随时停止。
        </p>
        <ul className="mt-4 space-y-1 text-left text-xs text-cream-dim/80">
          <li>· 我们不做实名认证，也不收集非必要个人信息</li>
          <li>· 双人玩法全程有「退出 / 安全词」，任何一方可立即结束</li>
          <li>· 内容全部来自可配置内容库，默认只开温和档</li>
        </ul>

        {declined ? (
          <div className="mt-5 rounded-xl border border-line bg-void-2/70 p-3 text-xs text-cream-dim">
            已为你退出。未成年人不适合访问本站，请关闭页面。
          </div>
        ) : (
          <div className="mt-5 flex flex-col gap-2">
            <Button
              onClick={() => {
                ageGate.confirm();
                setPassed(true);
              }}
            >
              我已年满 18 周岁，进入
            </Button>
            <Button variant="ghost" onClick={() => setDeclined(true)}>
              我未满 18 周岁
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}
